import { useQuery } from '@tanstack/react-query';
import ChatService from '../services/chat.service';

const chatService = new ChatService();

/**
 * Custom hook to fetch folder statistics using React Query's query.
 *
 * @param folderId - The ID of the folder to fetch statistics for.
 * @param organizationId - The ID of the organization to which the folder belongs.
 * @returns An object containing the query state and data.
 */
export const useFolderStatistics = (folderId?: string) => {
    return useQuery({
        queryKey: ['folderStatistics', folderId],
        queryFn: async () => {
            return await chatService.folderStatistics(folderId);
        },
    });
};
